/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IServerData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {INudgeParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeParsedGameData";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {DeadwoodGameMode} from "../../gamemode/DeadwoodGameMode";
import {DeadwoodServerDataParser} from "../DeadwoodServerDataParser";
import {IDeadwoodParsedServerData} from "./IDeadwoodParsedServerData";
import {IDeadwoodGameData} from "./IDeadwoodServerData";
import {DeadwoodGameModuleConfig} from "../../DeadwoodGameModuleConfig";

export class DeadwoodParsedGameData extends SpinParsedGameData implements INudgeParsedGameData, IDeadwoodParsedServerData {

    private readonly _doReelNudge:boolean[];
    private readonly _accumulatedRoundWin: string;

    get accumulatedRoundWin(): string {
        return this._accumulatedRoundWin;
    }

    public get doReelNudge():boolean[] {
        return this._doReelNudge;
    }

    private readonly _extraSymbolsOnTop:string[][];
    public get extraSymbolsOnTop():string[][] {
        return this._extraSymbolsOnTop;
    }

    private readonly _multiplierOnReel:number[];
    public get multiplierOnReel():number[] {
        return this._multiplierOnReel;
    }

    private readonly _bonusTriggeredThisSpin:boolean;
    public get bonusTriggeredThisSpin():boolean {
        return this._bonusTriggeredThisSpin;
    }

    private readonly _bonusPositions:number[];
    public get bonusPositions():number[] {
        return this._bonusPositions;
    }

    private readonly _fsSuperModeActive:boolean;
    public get fsSuperModeActive():boolean {
        return this._fsSuperModeActive;
    }

    private readonly _playerFSSelection:number;
    public get playerFSSelection():number {
        return this._playerFSSelection;
    }

    private readonly _numberOfSpinsFreespin:[number, number];
    public get numberOfSpinsFreespin():[number, number] {
        return this._numberOfSpinsFreespin;
    }

    constructor(rawData:IDeadwoodGameData, dataParser:DeadwoodServerDataParser) {
        super(rawData, dataParser);
        DeadwoodGameModuleConfig.isRestore=false;
        this._doReelNudge = dataParser.parseDoReelNudge(rawData);
        this._extraSymbolsOnTop = dataParser.parseExtraSymbolsOnTop(rawData, ArrayHelper.initArrayWithValues(GameConfig.instance.REELS_NUM, index => this.reels[index][0]));
        this._multiplierOnReel = dataParser.parseMultiplierOnReel(rawData);
        this._bonusTriggeredThisSpin = dataParser.parseBonusTriggeredThisSpin(rawData);
        this._bonusPositions = dataParser.parseBonusPositions(rawData);
        this._fsSuperModeActive = dataParser.parseFsSuperModeActive(rawData);
        this._playerFSSelection = dataParser.parsePlayerFSSelection(rawData);
        this._numberOfSpinsFreespin = dataParser.parseNumberOfSpinsFreespin(rawData);
        this._accumulatedRoundWin = dataParser.getAccumulatedRoundWin(rawData);
    }

    protected isFeatureTotalWin(rawData:IServerData):boolean {
        return this.mode === DeadwoodGameMode.FREESPIN_GUNSLINGER || this.mode === DeadwoodGameMode.FREESPIN_HUNTERS;
    }

    protected isNextFeatureTotalWin(rawData:IServerData):boolean {
        return this.nextMode === DeadwoodGameMode.FREESPIN_GUNSLINGER || this.nextMode === DeadwoodGameMode.FREESPIN_HUNTERS;
    }
}